import { render, staticRenderFns } from "./MerChant.vue?vue&type=template&id=f564e67a&scoped=true"
import script from "./MerChant.vue?vue&type=script&lang=js"
export * from "./MerChant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f564e67a",
  null
  
)

export default component.exports